export default function (closeIcon, modal) {
  closeIcon.addEventListener('click', () => {
    modal.style.display = 'none'; // eslint-disable-line no-param-reassign
    document.body.classList.toggle('no-scroll');
  });
}
